<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <!--  -->
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (onInsert)="doUIInsert($event)" (rowSelected)="agRowSelected($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <!-- <app-utymc-tabedit [srv]="srv"></app-utymc-tabedit> -->
    <div style="max-height: 400px; overflow-y: auto;">
      <div class="jk-grid-cols-2">
        <app-jktext label="customId" [value]="item.MC020">
        </app-jktext>
        <app-jktext label="流水號" [value]="item.MC002">
        </app-jktext>
        <app-jktext label="類別" [value]="item.MC010">
        </app-jktext>
        <app-jktext label="MAC_Address" [value]="item.MC004">
        </app-jktext>
        <app-jktext label="電腦名稱" [value]="item.MC011">
        </app-jktext>
        <app-jktext label="資料" [value]="item.MC006">
        </app-jktext>
        <app-jktext label="帳號" [value]="item.MC007">
        </app-jktext>
        <app-jktext label="密碼" [value]="item.MC008">
        </app-jktext>
        <app-jktext label="外部IP" [value]="item.MC003">
        </app-jktext>
        <app-jktext label="內部IP" [value]="item.MC009">
        </app-jktext>
        <app-jktextarea height="250px" label="備註" #MC005Com id="MC005" [(value)]="item.MC005" [readonly]="true">
        </app-jktextarea>
        <app-jkcheckboxYN label="alwaysOn" #MC012Com id="MC012" [(valueYN)]="item.MC012" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jktext label="VM主機" [value]="item.MC013">
        </app-jktext>
        <app-jkdatefield label="偵測時間" #MC014Com id="MC014" [(date)]="item.MC014" [readonly]="true">
        </app-jkdatefield>
        <app-jkcheckboxYN label="isOnline" #MC015Com id="MC015" [(valueYN)]="item.MC015" [readonly]="true">
        </app-jkcheckboxYN>
        <app-jktext label="shutdownAPI" [value]="item.MC016">
        </app-jktext>
        <app-jktext label="rebootAPI" [value]="item.MC017">
        </app-jktext>
        <app-jknumberedit label="apiPort" #MC018Com id="MC018" [(value)]="item.MC018" [readonly]="true">
        </app-jknumberedit>
        <app-jktext label="platform" [value]="item.MC019">
        </app-jktext>
        <app-jktext label="上次開機時間" [value]="item.MC021">
        </app-jktext>
        <app-jktext label="編號" [value]="item.MC001">
        </app-jktext>
      </div>
    </div>
  </mat-tab>

  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-[200px]">[空白]</div>
  </mat-tab>
</mat-tab-group>